import React, { FC, useEffect, useRef } from 'react';

interface EchartProps {
  option: { [ key: string ]: any };
  trigger: number;
  height: number;
  width?: string;
}
declare const echarts: { init: Function };
const Echart: FC<EchartProps> = ({ option, trigger, height, width }) => {
  const chartRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!chartRef.current || !trigger) return;
    const chart = echarts.init(chartRef.current);
    chart.setOption(option);
    window.addEventListener('resize', () => chart.resize());
  }, [ trigger ])

  return (<div style={{ height: `${height}px`, width: `${window.innerWidth > 768 ? (width || 100) : 100}%` }} ref={chartRef}></div>)
}

export default Echart;
